module.exports = __webpack_public_path__ + "static/media/Gerbera-Light.0bde949c.otf";